import type { SVGProp } from './types';

export const ducatCircle = (props: SVGProp) => (
  <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
    <path
      d="M15.0148 29.2483c7.8604 0 14.2326-6.3721 14.2326-14.2325 0-7.86046-6.3722-14.232597-14.2326-14.232597C7.15437.783203.782227 7.15534.782227 15.0158c0 7.8604 6.372143 14.2325 14.232573 14.2325Z"
      stroke="currentColor"
      strokeWidth="1.56508"
      strokeMiterlimit="10"
    />
    <path
      d="M15.0055 16.0814c.5257 0 .9519-.4262.9519-.9518 0-.5257-.4262-.9519-.9519-.9519-.5256 0-.9518.4262-.9518.9519 0 .5256.4262.9518.9518.9518Z"
      fill="currentColor"
    />
  </svg>
);
